import { Component, NgZone, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GlobalConstants } from '../iwgcommon/global-constants';
import { ListComponent } from '../iwgcommon/list/list.component';
import { AssignmentService } from '../shared/services/assignment.service';
import { NavbarService } from '../shared/services/navbar.service';
import { UserService } from '../shared/services/user.service';
import { Utils } from '../shared/utils/utils';
import{MatTableDataSource} from '@angular/material/table';
import { ListSearchParams } from '../shared/models/listsearchparams.model';
import { QuotesService } from '../shared/services/quotes.service';

@Component({
  selector: 'app-documents',
  templateUrl: './documents.component.html',
  styleUrls: ['./documents.component.scss']
})
export class DocumentsComponent extends ListComponent implements OnInit {

  activeiconcolor = 'quotes';

  selectedService = 1;
  selectedServiceName: string;
  ShowEOREstimator = false;
  labelPlural = '';
  ShowQuotesButton = false;
  sub: any;
  state: ListSearchParams;

  allowEndClients = false;
  USEORDisabled = false;

  USComplianceDisabled = false;
  USAORDisabled = false;
  InternationalEORDisabled = false;
  InternationalComplianceDisabled = false;
  InternationalAORDisabled = false;
  ShowEngageButton = false;
  showCompliance = false;
  labelSingular = '';

  globalScopes: any;
  hideColsInExport: number[];
  lastColIndex = 12; 

  constructor(private router: Router, utils: Utils, userService: UserService,
              public nav: NavbarService, renderer: Renderer2, public route: ActivatedRoute,
              quotesService: QuotesService, zone: NgZone) {
    super(quotesService, utils, renderer, userService, zone );
    this.globalScopes = GlobalConstants.globalScopes;

    this.router.routeReuseStrategy.shouldReuseRoute = (): boolean => {
      return false;
    };
  }

  ngOnInit(): void {

    this.nav.show();
    this.nav.setActiveMenu('services');
    this.nav.setActiveModuleMenu({'isVisible':true, 'activeMenu':'services'});
    this.state = {limit: 25, page: 1, service: 1, global_scope: 1, country: -1};

    this.route.queryParams.subscribe(params => {
      if (params) {
        this.selectedService = +params.service;

        this.state = Object.assign({}, this.state, (params));
        if (!this.state.service) {
          this.state.service = 1;
        }
        if (params.start) {
          this.state.start = new Date(params.start);
        }
        if (params.end) {
          this.state.end = new Date(params.end);
        }

      }
    });

    super.ngOnInit();

    this.selectedServiceName = this.utils.getServiceName(this.selectedService);
    this.service = this.selectedService;
    this.allowEndClients = this.userService.getAllowEndClients();

      if (this.userService.getEOREstimatorAccess()) {
        this.ShowEOREstimator = true;
    } else {
        this.ShowEOREstimator = false;
    }
    var role = this.userService.getRole();
    if (role == 'Worker') {
        this.ShowEOREstimator = false;
    }
    this.USEORDisabled = this.userService.getUSEORDisabled();
    this.USComplianceDisabled = this.userService.getUSComplianceDisabled();
    this.USAORDisabled = this.userService.getUSAORDisabled();
    this.InternationalEORDisabled = this.userService.getInternationalEORDisabled();
    this.InternationalComplianceDisabled = this.userService.getInternationalComplianceDisabled();
    this.InternationalAORDisabled = this.userService.getInternationalAORDisabled();

    this.ShowQuotesButton = !this.userService.getNewQuotesDisabled();
    this.ShowEngageButton = !this.userService.getNewEngageDisabled();
    this.showCompliance = !this.userService.getEvaluateButtonDisabled();

    this.selectedServiceName = this.utils.getServiceName(this.selectedService);
    if (this.selectedServiceName === 'Employer of Record') {
      this.labelSingular = 'Assignment';
    }
    else if (this.selectedServiceName === 'Agent of Record') {
      this.labelSingular = 'Engagement';
    }
    else if (this.selectedServiceName === 'Compliance') {
      this.labelSingular = 'Evaluation';
    }
    this.labelPlural = this.labelSingular + 's';

    this.listColumns = ['QuoteID', 'Title', 'EndClient', 'JobTitle', 'Location', 'StatusName', 'WorkerCount',
      'DateRequested', 'Expiration', 'Price', 'ClientMarkup', 'SalesTax', 'OprMenu'];

    this.generateListColumns();
    this.setStateParams();
    this.getItems();

  }

  generateListColumns(): void {

    this.displayedColumns = [...this.listColumns];
    this.lastColIndex = 12;


    if (!this.userService.getAllowEndClients()) {
      this.removeColFromDisplay('EndClient');
      this.lastColIndex--;
    }

    if (this.service !== 1) {
      this.removeColFromDisplay('JobTitle');
      this.removeColFromDisplay('WorkerCount');
      this.removeColFromDisplay('Expiration');
      this.lastColIndex = this.lastColIndex - 3;
    }

    if (this.service === 2) {
      this.removeColFromDisplay('Price');
      this.lastColIndex--;
    } else {
      this.removeColFromDisplay('ClientMarkup');
      this.removeColFromDisplay('SalesTax');
      this.lastColIndex = this.lastColIndex - 2;

    }
    this.hideColsInExport = [this.lastColIndex];

  }

  showQuoteEstimator = (ev) => {
    this.router.navigate(['/quoteEstimator/7b57522b-d0d6-403c-b524-1f0e2f24003c'],
        {queryParams:{service: this.state.service, global_scope: this.state.service}});

  }

}
